<template>
  <el-dialog
    :title="title"
    :visible.sync="isInfo"
    :close-on-click-modal="false"
  >
    <el-form>
      <el-form-item label="反馈人：">
        <span>{{ fObject.feedbackUserName }}</span>
      </el-form-item>
      <el-form-item label="问题类型：">
        <span>{{ fObject.feedbackQuestionTypeName }}</span>
      </el-form-item>
      <el-form-item label="反馈内容：">
        <span>{{ fObject.feedbackContent }}</span>
      </el-form-item>
      <el-form-item label="反馈时间：">
        <span>{{ fObject.createDate }}</span>
      </el-form-item>
      <el-form-item label="反馈渠道：">
        <span>{{ fObject.feedbackChannelName }}</span>
      </el-form-item>
      <el-form-item label="处理人：">
        <span>{{ fObject.handleUserName }}</span>
      </el-form-item>
      <el-form-item label="处理时间：">
        <span>{{ fObject.handleDate }}</span>
      </el-form-item>
      <el-form-item label="处理意见：">
        <span>{{ fObject.handleNotes }}</span>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
import Bus from "./Bus";
import { feedbackInfo } from "@/api/feedback";

export default {
  name: "detail",
  data() {
    return {
      isInfo: false,
      title: "反馈详情",
      fObject: {}
    };
  },
  methods: {
    info(uuid) {
      feedbackInfo(uuid).then(res => {
        if (res && res.code == 0) {
          this.fObject = res.data;
        }
      });
    }
  },
  created() {
    Bus.$on("feedbackInfo", uuid => {
      this.isInfo = true;
      this.title = "详情";
      this.info(uuid);
    });
  }
};
</script>
